import { Box } from "@mui/material";

const dotStyle = {
  width: 6,
  height: 6,
  borderRadius: "50%",
  bgcolor: "text.primary",
  animation: "dotPulse 1s infinite ease-in-out",
  "@keyframes dotPulse": {
    "0%, 80%, 100%": { transform: "scale(0.8)" },
    "40%": { transform: "scale(1.2)" },
  },
};

const DotLoader = ({ sx }) => (
  <Box sx={{ display: "flex", justifyContent: "center", gap: "4px", ...sx }}>
    <Box sx={dotStyle} />
    <Box sx={{ ...dotStyle, animationDelay: "0.2s" }} />
    <Box sx={{ ...dotStyle, animationDelay: "0.4s" }} />
  </Box>
);

export default DotLoader;
